import styled from "styled-components/macro";
import { Box } from "@mui/material";

export const FormMessageWrapper = styled(Box)`
  min-height: 50px;
  max-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
